export default __webpack_public_path__ + "static/media/item6.99c3b64d.png";